import apiCall from 'auth/ApiCallInstance';
import axios from 'axios';
import { API_BASE_URL } from 'configs/AppConfig';

const AuthService = {};

// Login - uses apiCall but with skipAuth since we don't have token yet
AuthService.login = function (data) {
  return apiCall({
    url: '/auth/login',
		method: 'post',
    data: data,
    skipAuth: true, // No token needed for login
  });
};

// Register
AuthService.register = function (data) {
  return apiCall({
    url: '/auth/register',
		method: 'post',
    data: data,
    skipAuth: true,
  });
};

// Refresh token - use plain axios to avoid interceptor loops
AuthService.refreshToken = async function (refreshToken) {
	try {
		const response = await axios.post(`${API_BASE_URL}/auth/refresh`, {
      refreshToken,
		});
		return response.data;
	} catch (error) {
		throw error;
	}
};

// Get current user
AuthService.getCurrentUser = function () {
  return apiCall({
    url: '/auth/me',
    method: 'get',
  });
};

// Logout
AuthService.logout = function (refreshToken) {
  return apiCall({
    url: '/auth/logout',
		method: 'post',
    data: { refreshToken },
  });
};

// Logout from all devices
AuthService.logoutAll = function () {
  return apiCall({
    url: '/auth/logout-all',
    method: 'post',
  });
};

// Change password
AuthService.changePassword = function (data) {
  return apiCall({
    url: '/auth/change-password',
		method: 'put',
    data: data,
  });
};

// Set password (for temporary password change)
AuthService.setPassword = function (data) {
  return apiCall({
    url: '/auth/set-password',
		method: 'put',
    data: data,
  });
};

export default AuthService;
